export const modalDescriptions = {
  airport: {
    title: 'Was ist in unserem Flughafentransfer enthalten?',
    subtitle: '✈️ Flughafentransfer',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Fahrzeug für Flughafentransfer',
    ariaLabel: {
      orderButton: 'Zum Buchungsformular für den Flughafentransfer',
      orderButtonText: 'Transfer buchen',
      closeButton: 'Modalfenster schließen',
    },
    list: [
      'Der Fahrer empfängt Sie mit einem Namensschild am Terminalausgang.',
      'Gepäckhilfe inklusive.',
      'Flugverfolgung (wir wissen, wenn Ihr Flug verspätet ist).',
      'Bis zu 60 Minuten Wartezeit kostenlos.',
      'Premium-Fahrzeuge (Wi-Fi, Wasser, Kindersitz auf Anfrage).',
      'Verfügbare Strecken: zum/vom Flughafen Václav Havel.',
      'Preise ab 30 Euro.',
    ],
    text: 'Unser Flughafentransfer sorgt für einen entspannten Start oder Abschluss Ihrer Reise. Wir verfolgen Ihren Flug und erwarten Sie mit einem Namensschild im Ankunftsbereich. Der Fahrer hilft mit dem Gepäck und bringt Sie in einem komfortablen Fahrzeug mit Wi-Fi direkt zu Ihrer Adresse. Die erste Stunde Wartezeit ist kostenlos – ideal bei Flugverspätung.',
  },

  corporate: {
    title: 'Die ideale Lösung für Unternehmen',
    subtitle: '🧑‍💼 Geschäftstransfer',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Business-Class-Fahrzeug für Firmenkunden',
    ariaLabel: {
      orderButton: 'Zum Buchungsformular für den Geschäftstransfer',
      orderButtonText: 'Transfer buchen',
      closeButton: 'Modalfenster schließen',
    },
    list: [
      'Service für Firmenkunden.',
      'Möglichkeit zum Vertragsabschluss mit Unternehmen.',
      'Monatliche Abrechnung und Berichterstattung.',
      'Fahrer im Anzug, diskrete Fahrten.',
      'Fahrzeuge ab Business-Class.',
      'Verfügbar für Events, Konferenzen und Delegationen.',
      'Routenverfolgung über das Firmenportal.',
    ],
    text: 'Wir bieten einen Premium-Service für Unternehmen, die Wert auf Komfort und Pünktlichkeit legen. Transfers zwischen Hotels, Konferenzzentren und Flughäfen werden von erfahrenen Chauffeuren durchgeführt. Ein Vertragsabschluss mit monatlicher Abrechnung ist möglich. Ihre Mitarbeiter werden sicher und rechtzeitig an ihr Ziel gebracht.',
  },

  personal: {
    title: 'Ihr Fahrer für einen Tag, eine Woche oder eine Reise',
    subtitle: '🚗 Persönlicher Chauffeur',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Persönlicher Chauffeur mit Premium-Fahrzeug',
    ariaLabel: {
      orderButton: 'Zum Buchungsformular für persönlichen Fahrer',
      orderButtonText: 'Fahrer buchen',
      closeButton: 'Modalfenster schließen',
    },
    list: [
      'Stundenweise oder ganztägige Buchung möglich.',
      'Fahrten innerhalb der Stadt, Stopps und Wartezeiten inklusive.',
      'Premium-Fahrzeuge mit Chauffeur.',
      'Private Fahrten, Shopping-Touren, wichtige Termine.',
      'Ideal für Touristen, VIPs und Senioren.',
      'Fahrer sprechen Englisch und Tschechisch.',
    ],
    text: 'Ein persönlicher Chauffeur ist die perfekte Lösung für alle, die flexibel und sorgenfrei unterwegs sein möchten. Unser Fahrer begleitet Sie während der gesamten Route – egal wie kompliziert. Ideal für Shopping, Geschäftstermine oder Ausflüge. Premium-Fahrzeug, freundlicher Service und volle Diskretion inklusive.',
  },

  vip: {
    title: 'Luxus und Komfort auf höchstem Niveau',
    subtitle: '👑 VIP- und Luxusservice',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'VIP-Fahrzeug bereit zur Abfahrt',
    ariaLabel: {
      orderButton: 'Zum Buchungsformular für VIP-Service',
      orderButtonText: 'VIP-Transfer buchen',
      closeButton: 'Modalfenster schließen',
    },
    list: [
      'Individuelle Betreuung jedes Kunden.',
      'Fahrzeuge der höchsten Kategorie.',
      'Fahrer im Anzug mit VIP-Erfahrung.',
      'Absolute Diskretion.',
      'Zusatzoptionen: Willkommenspaket, Mineralwasser, Zeitungen.',
      'Ideal für Geschäftstreffen, diplomatische Fahrten, Hochzeiten und Events.',
      '24/7 Support und persönlicher Ansprechpartner.',
    ],
    text: 'Ein persönlicher Chauffeur ist die perfekte Lösung für alle, die flexibel und sorgenfrei unterwegs sein möchten. Unser Fahrer begleitet Sie während der gesamten Route – egal wie kompliziert. Ideal für Shopping, Geschäftstermine oder Ausflüge. Premium-Fahrzeug, freundlicher Service und volle Diskretion inklusive.',
  },

  tours: {
    title: 'Reisen Sie komfortabel und mit Freude',
    subtitle: '🌍 Touren und Ausflüge',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Fahrzeug für Touren und Ausflüge durch Europa',
    ariaLabel: {
      orderButton: 'Zum Buchungsformular für Tour oder Ausflug',
      orderButtonText: 'Tour buchen',
      closeButton: 'Modalfenster schließen',
    },
    list: [
      'Organisation von individuellen und Gruppenreisen.',
      'Wahlmöglichkeit: mit Guide oder nur Fahrer.',
      'Flexible Routen in Tschechien und Europa (Karlsbad, Wien, Dresden, München usw.).',
      'Komfortable Fahrzeuge mit Klimaanlage, Wi-Fi, Trinkwasser.',
      'Foto-Stopps, Zeit für Shopping, lokale Restaurants.',
      'Reiseversicherung und Unterstützung während der Fahrt.',
      'Online-Buchung möglich.',
    ],
    text: 'Entdecken Sie Europa mit uns – stressfrei und bequem. Wir organisieren individuelle oder Gruppenreisen ganz nach Ihren Wünschen. Sie können mit Guide reisen oder einfach die komfortable Fahrt mit einem Profi-Fahrer genießen. Unsere Touren sind auf Sicherheit, Komfort und unvergessliche Erlebnisse ausgelegt.',
  },
};
